module.exports = __webpack_public_path__ + "static/basic-info-2c9fcb5b005b19f0caf4e8b7af73a70a.gif";